import script from "./timed-assertive-badge.vue?vue&type=script&setup=true&lang=ts"
export * from "./timed-assertive-badge.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__